export const configurationsMixin = {
  data(){
    return {
        polygon: null,
        workspace: null
    }
  },
  methods: {
    convertToGeoJSON(inputString) {
      const coordinatesStr = inputString.match(/\(\(([^)]+)\)\)/)[1];
      const pairs = coordinatesStr.split(",");
      // Transform the coordinates into the desired format
      const coordinates = pairs.map(pair => {
          const [x, y] = pair.trim().split(" ");
          return [parseFloat(x), parseFloat(y)];
      });
        
      // Create the GeoJSON object
      const geoJSON = {
          type: "MultiPolygon",
          coordinates: [[coordinates]]
      };

      return JSON.stringify(geoJSON);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/npv/configurationsMixin.js